<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Error from '@/components/Error.vue';

const { t } = useI18n();
</script>

<template>
  <error
    :icon="'mdi-link-off'"
    :title="t('notFoundPage.title')"
    :message="t('notFoundPage.message')" />
</template>
